import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import logo from "../../common/media/cc_logo_white.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProjectsList from "./../Projects/ProjectsList";
import { Carousel } from 'react-responsive-carousel';
import { projects as getProjects } from '../../common/api/projects'
import { getKilometersFromCo2Amount as getKilometers }  from "../../common/util/converterUtils";
import FlightCalculator from "../../common/components/offset/FlightCalculatorV2";
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';

const LandingPage = ({ merchantCode, fetchedImpact }) => {
    const [projects, setProjects] = useState();
    const [count, setCount] = useState(1);
    const [isVisible, setIsVisible] = useState(true);

    const decrementCount = () => {
        if (count > 0) setCount(count - 1);
    };

    const incrementCount = () => {
        setCount(count + 1);
    };
    
    const numberOfContributions = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.numberOfContributions?.value);
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase()
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);
    
    const classFly = `Lorem ipsum set amit`;
    
    
    useEffect(() => {
        getProjects(null, merchantCode)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

    }, []);


    const kmsDriven = fetchedImpact && getKilometers(fetchedImpact.carbonOffsetImpact);

    const kmsDrivenText = `An average small car emits about 156 grams CO2 per kilometer. By funding projects that offset carbon emissions, that’s having the same impact as making ${`${kmsDriven ? Math.round(kmsDriven).toLocaleString() : ''} km`} carbon neutral`;
    return (
        <div>
        <header className="position-relative text-center bg-white py-3">
            <a className="navbar-brand" target="_blank" href="https://aci-lac.aero/conference2021/"><img src={`https://res.cloudinary.com/carbonclick/image/upload/v1635151340/Enterprise/ACI-LAC/waga-logo_nu1ovn.png`} alt="" style={{height: '74px'}} /></a>
        </header>
        <div className="w-100 hero-img cl-to-act position-relative vertical-align-parent banner-sec" >
            <div className="container color-white text-left">
                <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1636317690/Enterprise/ACI-LAC/aci_kdzkln.png`} alt="" className='banner-logos'/>
                <h3 className="text-center mt-0 color-white"><b>RUNWAY TO RECOVERY:</b></h3>
                <h3 className="text-center mt-0 color-white">Reconnecting Aviation for a Sustainable Future</h3>
                <div className="mw-850px text-center mx-auto">
                    <p className="mb-4 font-light">The 2021 ACI -  LAC WAGA event is empowering every attendee to offset the emissions from their flights.</p>
                    <a className="btn-cc btn-orange mt-2 mb-4 mobile-hide color-white" href="#FlightCalculator">Offset My Flight</a>

                    <div className="col-md-4 mb-3 mobile-show text-md-right">
                        <a className="btn-cc btn-orange color-white" href="#FlightCalculatorDummy">Offset My Flight</a>
                    </div>
                    <div className="d-flex mobile-hide justify-content-center mt-2 pb-4">
                        <p className="mr-2 mt-0 pow mb-0">Powered by</p>
                        <div>
                            <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 20 }} src={logo} /></a>
                        </div>
                    </div>
                </div>

            </div>

            <div className="mobile-show pwr-bix">
                <div className="bg-primary p-3 text-center">
                    <div className="d-flex w-fit center color-white">
                        <p className="mr-2 mt-0 mb-0 pow">Powered by</p>
                        <div>
                            <a className="d-flex mt-1" target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 16 }} src={logo} /></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div className="cl-to-act py-5">
                <div className="container">
                    <h3 className="mt-0"><b>ARE YOU AN AIRPORT INTERESTED IN THE OFFSETTING PROGRAM?</b></h3>
                    <div className="row align-items-center">
                        <div className="col-md-8">
                            <p>Find out more about how you can partner with CarbonClick to introduce a voluntary carbon offset program into your airport.</p>
                        </div>
                        <div className="col-md-4 text-md-right">
                            <a className="btn-cc btn-orange color-white" href="https://www.carbonclick.com/business/aviation/airports/">Find out more</a>
                        </div>
                    </div>
                </div>
            </div>
        <div className="vdo-sec section-padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg">
                        <h2 className="font-bold mw-720px">LET’S RECONNECT SUSTAINABLY</h2>
                        <p className="mw-720px mb-0">We’ve partnered with CarbonClick to help you effortlessly reduce the environmental impact of your trip and support high impact projects that make a real, measurable difference. Together we are fighting climate change.</p>
                        <a href="https://www.carbonclick.com/business/aviation/airports/" className="learnMore mt-3">Learn more <img className="ml-2" src="https://res.cloudinary.com/carbonclick/image/upload/v1635152749/Enterprise/ACI-LAC/arrow_yg7rvk.svg"/></a>
                    </div>
                    <div className="col-lg-auto">
                        <div className="videoBx"><iframe src="https://player.vimeo.com/video/569642107?h=1b7c54c51a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Climate Friendly Traveller"></iframe></div>
                        <script src="https://player.vimeo.com/api/player.js"></script>
                    </div>
                </div>
                
            </div>
        </div>
        <div id="FlightCalculator" className="calculator-sec section-padding">
            <div className="container mobile-p-0">
                <div className="center shadow-lg">
                    <div id="FlightCalculatorDummy"/>
                    <FlightCalculator merchantCode={merchantCode} />
                </div>
            </div>
        </div>
        <div className="vdo-sec section-padding testimonial-sec pb-0">
            <div className="container">
                <Carousel dynamicHeight={false} showThumbs={false} showStatus={false} infiniteLoop={true} autoPlay={true} showArrows={true} showIndicators={false}>
                    <div key="1" >
                        <div className="row align-items-center">
                            <div className="col-md-5">
                                <div className="sliderImg">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/c_fill,g_face,h_300,w_300/v1635635181/Enterprise/ACI-LAC/IMG_4613_djwpto.jpg"/>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="sliderText px-4">
                                    <p className="big text-left">“As part of our commitment towards reducing the impact of aviation on the environment, we are proud to announce that for the first time we are providing the opportunity at our #WAGA2021 Annual Conference to all of our participants to offset the CO2 emissions from their travel to attend the conference to reduce the impact on the environment. At ACI-LAC, we are very excited about this initiative and we continue leading our efforts that are committed to the goal of Net Zero by 2050.”</p>
                                    <p className="text-left"><span className="seprator"></span></p>
                                    <p className="rev-detail text-left">Rafael Echevarne <span>/ Director General at ACI-LAC</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel>
                
            </div>
        </div>
        <div className="cl-to-act py-5 mt-5">
            <div className="container">
                <h3 className="mt-0"><b>ARE YOU AN AIRPORT INTERESTED IN THE OFFSETTING PROGRAM?</b></h3>
                <div className="row align-items-center">
                    <div className="col-md-8">
                        <p>Find out more about how you can partner with CarbonClick to introduce a voluntary carbon offset program into your airport.</p>
                    </div>
                    <div className="col-md-4 text-md-right">
                        <a className="btn-cc btn-orange color-white" href="https://www.carbonclick.com/business/aviation/airports/">Find out more</a>
                    </div>
                </div>
            </div>
        </div>
        <div id="our-project" className="section-padding">
            {Array.isArray(projects) && <>
                <div className="container">
                    <div className="px-3 mw-550px w-100 center mb-4">
                        <h2 className="font-medium mb-3">SUPPORT PROJECTS THAT FIGHT CLIMATE CHANGE</h2>
                        <p className="w-100 mt-2 medium">We support only the highest quality carbon offsetting projects around the world, to bring you peace of mind and results.</p>
                    </div>
                    <ProjectsList title={null} projects={projects} />
                </div>
            </>}
        </div>

        <div className="py-6 mobile-p-0">
            <div className="container text-center">
                <h3 className="font-bold mb-4">Climate Friendly Traveller FAQs</h3>
                <div className="mb-3 center text-align-start mw-800px">
                    <Accordian title={"What does carbon offsetting do?"} >Carbon offsetting is a tool that allows individuals or companies to reduce their environmental impact. Purchasing carbon offsets supports environmental projects that remove greenhouse gases from the air, these projects could be things like reforestation projects or investment into renewable energy. Purchasing one carbon offset credit removes the equivalent of one tonne of CO<sub>2</sub> from the atmosphere.</Accordian>
                    <Accordian title={"What is a carbon offset?"} >A carbon credit is what is bought and sold when dealing with voluntary carbon offsets. For every tonne of CO<sub>2</sub> that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are independently certified by international standards and held in registries like the UK Land Carbon Registry or the Gold Standard Registry.</Accordian>
                    <Accordian title={"How are flight emissions calculated?"}>Emissions are calculated based on the individual route flown, taking into account the distance travelled as well as the type of aircraft, seating configuration, aircraft age, and typical load factors on your particular route.</Accordian>
                    <Accordian title={"What about radiative forcing?"}>Due to the ongoing scientific debate and significant uncertainty about the effects of non-CO<sub>2</sub> emissions,    CarbonClick’s calculations do not currently include the effects of radiative forcing.</Accordian>
                    <Accordian title={"Who are CarbonClick?"} >CarbonClick are a New Zealand-based company that exists to reverse climate change. CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective, building a happier and more sustainable future for everyone.</Accordian>
                    <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                    <Accordian title={"How do I know the offset is trustworthy?"} >CarbonClick is committed to making carbon offsetting safe and trustworthy, we do this by tracing every transaction to the projects it supported so you can see the retirement certificates for every kg of CO<sub>2</sub> offset. The trace link is sent in every purchase confirmation email, and can also be found on our website.</Accordian>                    
                </div>
                <a href={footerLinks?.faq} target="_blank" rel="noopener noreferrer" className="btn-cc btn-orange mx-auto px-5 mt-3 color-white" >View All</a>
                <div className="mobile-show py-5"></div>
            </div>
        </div>

        <div className="w-100 img-cover footer-img py-7 bg-footer">
            <div className="container color-white py-5">
                <p><b>Powered by</b></p>
                <div className="d-flex">
                    <div>
                        <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                            <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                        </a>
                    </div>
                    <div className="right">
                        <div>
                            <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                            </a>
                            <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                            </a>
                            <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                            </a>
                        </div>
                    </div>
                </div>
                <hr className="mb-4" />
                <div className="row">
                    <div className="col-4">
                        <div>
                            <div className="mb-3"><a className="color-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            <div className="mb-3"><a className="color-white" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div>
                            <div className="mb-3"><a className="color-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                            <div className="mb-3"><a className="color-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div>
                            <div className="mb-3"><a className="color-white" href="mailto:hello+acilac@carbonclick.com" target="_blank" rel="noopener noreferrer">hello@carbonclick.com</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}


export default LandingPage;